<template>
  <div class="demo-sub-layout">
    <DemoTopNav />
    <div class="demo-sub-layout__body">
      <aside
        v-show="!isNarrow"
        class="demo-sub-layout__lnb"
        aria-label="이커머스 운영 메뉴"
      >
        <el-menu
          :key="'ops-' + activeMenuKey"
          :default-active="activeMenuKey"
          class="demo-sub-layout__menu"
          background-color="#fff"
          text-color="#606266"
          active-text-color="#254aa5"
          @select="onOpsMenuSelect"
        >
          <div class="demo-sub-layout__menu-label">이커머스 운영</div>
          <el-menu-item index="ops-overview">
            <i class="el-icon-data-board" />
            <span>대시보드</span>
          </el-menu-item>
          <el-menu-item index="ops-sales" disabled>
            <i class="el-icon-sell" />
            <span class="demo-sub-layout__menu-item-text">
              매출·주문 분석
              <span class="demo-sub-layout__menu-soon">준비 중</span>
            </span>
          </el-menu-item>
          <el-menu-item index="ops-channel" disabled>
            <i class="el-icon-share" />
            <span class="demo-sub-layout__menu-item-text">
              채널·캠페인 성과
              <span class="demo-sub-layout__menu-soon">준비 중</span>
            </span>
          </el-menu-item>
          <el-menu-item index="ops-product">
            <i class="el-icon-goods" />
            <span>상품·재고 현황</span>
          </el-menu-item>
          <el-menu-item index="ops-customer" disabled>
            <i class="el-icon-user" />
            <span class="demo-sub-layout__menu-item-text">
              고객·리텐션
              <span class="demo-sub-layout__menu-soon">준비 중</span>
            </span>
          </el-menu-item>
        </el-menu>
      </aside>

      <el-drawer
        title="이커머스 운영"
        :visible.sync="drawerVisible"
        direction="ltr"
        size="280px"
        custom-class="demo-sub-layout__drawer"
        append-to-body
      >
        <el-menu
          :key="'ops-d-' + activeMenuKey"
          :default-active="activeMenuKey"
          class="demo-sub-layout__menu demo-sub-layout__menu--drawer"
          background-color="#fff"
          text-color="#606266"
          active-text-color="#254aa5"
          @select="onOpsMenuSelect"
        >
          <el-menu-item index="ops-overview">
            <i class="el-icon-data-board" />
            <span>대시보드</span>
          </el-menu-item>
          <el-menu-item index="ops-sales" disabled>
            <i class="el-icon-sell" />
            <span class="demo-sub-layout__menu-item-text">
              매출·주문 분석
              <span class="demo-sub-layout__menu-soon">준비 중</span>
            </span>
          </el-menu-item>
          <el-menu-item index="ops-channel" disabled>
            <i class="el-icon-share" />
            <span class="demo-sub-layout__menu-item-text">
              채널·캠페인 성과
              <span class="demo-sub-layout__menu-soon">준비 중</span>
            </span>
          </el-menu-item>
          <el-menu-item index="ops-product">
            <i class="el-icon-goods" />
            <span>상품·재고 현황</span>
          </el-menu-item>
          <el-menu-item index="ops-customer" disabled>
            <i class="el-icon-user" />
            <span class="demo-sub-layout__menu-item-text">
              고객·리텐션
              <span class="demo-sub-layout__menu-soon">준비 중</span>
            </span>
          </el-menu-item>
        </el-menu>
      </el-drawer>

      <div
        class="demo-sub-layout__main-wrap"
        :class="{ 'is-with-lnb': !isNarrow }"
      >
        <button
          v-if="isNarrow"
          type="button"
          class="demo-sub-layout__lnb-toggle"
          aria-label="운영 메뉴 열기"
          @click="drawerVisible = true"
        >
          <i class="el-icon-s-unfold" />
          <span>운영 메뉴</span>
        </button>
        <main class="demo-sub-layout__main">
          <router-view />
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import DemoTopNav from "@/components/demo/DemoTopNav.vue";

export default {
  name: "OperationsDashboardLayout",
  components: { DemoTopNav },
  data() {
    return {
      drawerVisible: false,
      isNarrow: false,
    };
  },
  computed: {
    activeMenuKey() {
      const key =
        this.$route.meta && this.$route.meta.menuKey
          ? this.$route.meta.menuKey
          : "ops-overview";
      return key;
    },
  },
  mounted() {
    this.mq = window.matchMedia("(max-width: 992px)");
    this.isNarrow = this.mq.matches;
    this.onMq = () => {
      this.isNarrow = this.mq.matches;
      if (!this.isNarrow) {
        this.drawerVisible = false;
      }
    };
    this.mq.addListener(this.onMq);
  },
  beforeDestroy() {
    if (this.mq && this.onMq) {
      this.mq.removeListener(this.onMq);
    }
  },
  methods: {
    onOpsMenuSelect(index) {
      if (this.isNarrow) {
        this.drawerVisible = false;
      }
      if (index === "ops-overview") {
        this.$router.push({ name: "DemoOperationsDashboard" }).catch(() => {});
        return;
      }
      if (index === "ops-product") {
        this.$router.push({ name: "DemoOperationsProduct" }).catch(() => {});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.demo-sub-layout {
  min-height: 100vh;
  padding-top: 56px;
  box-sizing: border-box;
  background: #f0f2f5;
}

.demo-sub-layout__body {
  display: flex;
  width: 100%;
  min-height: calc(100vh - 56px);
}

.demo-sub-layout__lnb {
  position: fixed;
  top: 56px;
  left: 0;
  bottom: 0;
  width: 228px;
  z-index: 150;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background: #fff;
  border-right: 1px solid #ebeef5;
  box-sizing: border-box;
}

.demo-sub-layout__menu {
  border-right: none !important;
  padding-top: 12px;
  padding-bottom: 16px;
}

.demo-sub-layout__menu-label {
  padding: 8px 20px 4px;
  font-size: 11px;
  font-weight: 600;
  color: #909399;
  letter-spacing: 0.04em;
}

.demo-sub-layout__menu-item-text {
  display: inline;
  white-space: normal;
  vertical-align: middle;
}

.demo-sub-layout__menu-soon {
  margin-left: 6px;
  font-size: 11px;
  font-weight: 500;
  color: #c0c4cc;
  letter-spacing: 0.02em;
}

.demo-sub-layout__menu ::v-deep .el-menu-item.is-disabled {
  cursor: not-allowed;
  opacity: 0.88;
}

.demo-sub-layout__menu ::v-deep .el-menu-item.is-disabled i {
  color: #dcdfe6 !important;
}

.demo-sub-layout__menu ::v-deep .el-menu-item {
  height: 46px;
  line-height: 46px;
  padding-left: 20px !important;
  margin: 2px 8px;
  border-radius: 8px;
}

.demo-sub-layout__menu ::v-deep .el-menu-item i {
  margin-right: 8px;
  color: #909399;
}

.demo-sub-layout__menu ::v-deep .el-menu-item.is-active {
  background: #ecf5ff !important;
  font-weight: 600;
}

.demo-sub-layout__menu ::v-deep .el-menu-item.is-active i {
  color: #254aa5;
}

.demo-sub-layout__menu--drawer {
  padding-top: 0;
}

.demo-sub-layout__main-wrap {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 56px);
  width: 100%;
}

.demo-sub-layout__main-wrap.is-with-lnb {
  margin-left: 228px;
  width: calc(100% - 228px);
  box-sizing: border-box;
}

.demo-sub-layout__lnb-toggle {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 12px 16px 0;
  padding: 10px 14px;
  width: calc(100% - 32px);
  max-width: 320px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  background: #fff;
  color: #606266;
  font-size: 14px;
  cursor: pointer;
  box-sizing: border-box;
}

.demo-sub-layout__lnb-toggle:hover {
  border-color: #254aa5;
  color: #254aa5;
}

.demo-sub-layout__lnb-toggle i {
  font-size: 18px;
}

.demo-sub-layout__main {
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
</style>

<style lang="scss">
.demo-sub-layout__drawer .el-drawer__header {
  margin-bottom: 12px;
  padding: 16px 20px 0;
  font-weight: 600;
  color: #303133;
}
</style>
